import React, { useEffect } from 'react';
import { Button, Card, Form, Input, Space, Switch } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import StoreSettingService from 'services/store_setting';
import { useApp } from 'contexts/app';

const service = new StoreSettingService();

const ScriptSetting = () => {
    const [form] = Form.useForm();
    const { showLoading, showNotify, message } = useApp();

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            const setting = await service.getScriptSetting();
            form.setFieldsValue({
                scripts: setting?.scripts ?? [],
            });
        } catch (error) {
            message.error('Không thể tải cấu hình script');
        }
    };

    const onFinish = async (values) => {
        showLoading(true);
        try {
            await service.saveScriptSetting({ scripts: values?.scripts ?? [] });
            await loadData();
            showNotify('Đã cập nhật');
        } catch (error) {
            message.error('Không thể cập nhật script');
        }
        showLoading(false);
    };

    return (
        <Card title="Script bên thứ ba">
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                autoComplete="off"
                initialValues={{ scripts: [] }}
            >
                <Form.List name="scripts">
                    {(fields, { add, remove }) => (
                        <Space direction="vertical" style={{ width: '100%' }} size={16}>
                            {fields.map((field, index) => (
                                <Card
                                    key={field.key}
                                    size="small"
                                    title={`Script ${index + 1}`}
                                    extra={
                                        <Button
                                            type="text"
                                            danger
                                            icon={<MinusCircleOutlined />}
                                            onClick={() => remove(field.name)}
                                        >
                                            Xóa
                                        </Button>
                                    }
                                >
                                    <Form.Item name={[field.name, 'id']} hidden>
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        label="Tên"
                                        name={[field.name, 'name']}
                                        rules={[{ required: true, message: 'Bạn phải nhập tên script' }]}
                                    >
                                        <Input placeholder="VD: Google Analytics" />
                                    </Form.Item>

                                    <Form.Item
                                        label="Bật"
                                        name={[field.name, 'enabled']}
                                        valuePropName="checked"
                                        initialValue={true}
                                    >
                                        <Switch checkedChildren="Bật" unCheckedChildren="Tắt" />
                                    </Form.Item>

                                    <Form.Item
                                        label="Code script"
                                        name={[field.name, 'code']}
                                        rules={[{ required: true, message: 'Bạn phải nhập code script' }]}
                                        extra="Dán đoạn code GA/Facebook Pixel (có thể dán cả thẻ <script> hoặc chỉ JS)."
                                    >
                                        <Input.TextArea rows={7} placeholder="Dán code script tại đây" />
                                    </Form.Item>
                                </Card>
                            ))}

                            <Button
                                type="dashed"
                                onClick={() => add({ enabled: true })}
                                icon={<PlusOutlined />}
                                block
                            >
                                Thêm script
                            </Button>
                        </Space>
                    )}
                </Form.List>

                <Form.Item style={{ marginTop: 16 }}>
                    <Button type="primary" htmlType="submit">
                        Cập nhật
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    );
};

export default ScriptSetting;
